const getHashParams = (): { [key: string]: string } => {
  const hashParameters = window.location.hash.slice(1).split(';');
  const hashObject: { [key: string]: string } = {};
  hashParameters.forEach((parameter) => {
    const keyValue = parameter.split('=');
    // eslint-disable-next-line prefer-destructuring
    hashObject[keyValue[0]] = keyValue[1];
  });
  return hashObject;
};

export default getHashParams;
